
import { TasksState } from "@/utils/tasks-state";
import Vue from "vue";
import { Task } from "../../models/tasks/task";
import { TaskService } from "../../services/task-service";
import AppTaskInfoWrapper from "./TaskInfoWrapper.vue";
import { ChatState } from "@/utils/chat-state";
import AppChatMessages from "@/components/chat-components/ChatMessages.vue";
import { ChatMessage } from "../../utils/chat-message";
import { DossierService } from "../../services/dossier-service";
import { TaskMessage } from "../../models/tasks/task-message";
import { MainSocketService } from "../../services/main-socket-service";
import AppMessageInput from "@/components/chat-components/MessageInput.vue";
import AppTaskEdit from "./TaskEditModal.vue";

export default Vue.extend({
	data() {
		return {
			message: "",
			chatState: new ChatState(),
			isFetchingMessages: false,
			topReached: false,
			editModal: false,
			editTask: new Task()
		};
	},
	props: {
		state: {
			type: Object as () => TasksState,
			required: true
		}
	},
	computed: {
		task(): Task {
			return this.state.openedTask as Task;
		},
		messages():ChatMessage[]{
			return this.task.Messages.map(t=>t.toChatMessage());
		}
	},
	methods: {
		async edit(){
			this.editTask = await TaskService.getTask(this.task.ID);
			this.editModal = true;
		},
		async sendMessage() {
			await TaskService.postMessage(this.task.ID, this.message, null);
			this.message = "";
		},
		async sendFile(file:File){
			await TaskService.postMessage(this.task.ID, "", file);
		},
		async onNewMessage(message: any) {
			this.task.Messages.unshift(new TaskMessage(message));
			this.task.sortMessages();
			this.$emit("should-scroll-down");
		},
		async onUpdateMessage(data: any) {
			let message = new TaskMessage(data);
			let index = this.task.Messages.findIndex(m => m.ID == message.ID);
			this.task.Messages[index] = message;
			this.task.sortMessages();
			this.$emit("should-scroll-down");
		},
		async fetchMoreMessages(){
			if (this.isFetchingMessages) return;
			if (this.topReached) return;
			this.isFetchingMessages = true;
			let messageCount = this.task.Messages.length;
			try{
				await this.task.fetchMessages();
				if (this.task.Messages.length == messageCount){
					this.topReached = true;
				}
			}catch(err){}
			this.isFetchingMessages = false;
		},
		async refresh(){
			if (!this.state.openedTask) return;
			this.state.openedTask = await TaskService.getTask(this.state.openedTask.ID);
			this.state.openedFolder = await TaskService.getFolder(this.state.openedTask.FolderID);
		},
		async remove(){
			let confirm = await this.$wf.confirm(this.$ct("confirm-delete-this-task"), this.$ct("common.yes"), this.$ct("common.no"), this.$ct("common.warning"), "warning");
			if (!confirm) return;
			this.editModal = false;
			await TaskService.deleteTask(this.task);
			if (this.state.openedFolder){
				this.$router.push(`/tasks/${this.state.openedFolder}`);
			}else{
				this.$router.push(`/tasks`);
			}
		}
	},
	async created(){
		await DossierService.getUsers();
		MainSocketService.on(`/tasks/${this.task.ID}/message/new`, this.onNewMessage, this);
		MainSocketService.on(`/tasks/${this.task.ID}/message/update`, this.onUpdateMessage, this);
		await TaskService.markMessagesAsRead(this.task.ID);
	},
	async beforeDestroy() {
		MainSocketService.offAll(this);
	},
	mounted() {
		this.fetchMoreMessages();
	},
	components: {
		AppTaskInfoWrapper,
		AppChatMessages,
		AppMessageInput,
		AppTaskEdit
	},
	i18nEx: {
		componentPrefix: "components.tasks"
	}
});
